import { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import DashboardView from "@/components/DashboardView";
import DashboardCalendar from "@/components/DashboardCalendar";
import MaestroOnboarding from "@/components/MaestroOnboarding";
import OverloadAlerts from "@/components/OverloadAlerts";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function DashboardHome() {
  const { user } = useAuth();
  const [projectCount, setProjectCount] = useState(null);
  const [onboardingOn, setOnboardingOn] = useState(null);
  const hour = new Date().getHours();
  const greet = hour < 12 ? "Good morning" : hour < 17 ? "Good afternoon" : "Good evening";
  const firstName = (user?.name || "").split(" ")[0];

  useEffect(() => {
    if (user && !user.tour_done) {
      api.get("/projects").then(({ data }) => setProjectCount((data || []).length)).catch(() => setProjectCount(null));
      api.get("/settings/onboarding").then(({ data }) => setOnboardingOn(!!data.enabled)).catch(() => setOnboardingOn(true));
    }
  }, [user]);

  const showTour = user && !user.tour_done && projectCount === 0 && onboardingOn === true;
  return (
    <Layout>
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-8" data-testid="dashboard-home">
        <div className="mb-6">
          <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight" data-testid="dashboard-home-title">
            {greet}{firstName ? `, ${firstName}` : ""}
          </h1>
          <p className="text-sm text-muted-foreground mt-1">Here's your whole project stack at a glance. Click any project, stat, or status pill to dig in.</p>
        </div>
        <OverloadAlerts />
        <DashboardView />
        <DashboardCalendar />
      </div>
      {showTour && <MaestroOnboarding firstName={firstName} />}
    </Layout>
  );
}
